import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        iconboxCard: {
            gap: remCalc(16),
            justifyContent: 'center',
            alignContent: 'center',
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: {base: remCalc(151), md: '100%'},
        },
        icon: {
            height: 'iconsSize.xlarge',
            width: 'iconsSize.xlarge',
            margin: 'auto',
        },
        contentWrapper: {
            flexDirection: 'column',
            justifyContent: 'center',
        },
        title: {
            textStyle: 'body-medium',
        },
        subtitle: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
        sectionContainer: {
            direction: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: {base: remCalc(40), md: remCalc(60)},
            paddingX: {base: remCalc(16), lg: remCalc(0)},
            paddingBottom: {base: remCalc(40), md: remCalc(80)},
            margin: '0 auto',
            w: '100%',
            maxWidth: remCalc(1400),
        },
        sectionTitle: {
            textStyle: 'head-large',
            fontWeight: '500',
        },
        cardsWrapper: {
            direction: 'column',
            gap: remCalc(24),
            width: '100%',
        },
        cardsRow: {
            gap: remCalc(20),
            justifyContent: {base: 'space-evenly', md: 'space-between'},
            width: '100%',
        },
        separator: {
            width: remCalc(1),
            height: {md: remCalc(110)},
            backgroundColor: 'border.light',
            alignSelf: {base: 'stretch', md: 'center'},
        },
        emptySpace: {
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: {base: remCalc(151), md: '100%'},
        },
        actionButton: {
            maxWidth: {md: remCalc(332)},
            width: '100%',
        },
    },
    variants: {},
}
